/*
 * Copyright (c) 2021 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import React from 'react';
import { toggleWidget } from 'react-chat-widget';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import './styles';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/:botId" element={<App />}></Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('chat-bot-app')
);

datadogRum.init({
  applicationId: '576b16a5-3393-4910-9801-bb7511328d65',
  clientToken: 'pub842638cd4390b6da8168ffc02aa42c7e',
  site: 'datadoghq.com',
  service: 'web-chat-bot',
  env: window['DD-ENV'],
  version: '2.2.0',
  sampleRate: 100,
  trackInteractions: true,
  useCrossSiteSessionCookie: true,
  defaultPrivacyLevel: 'mask-user-input'
});

datadogLogs.init({
  clientToken: 'pub842638cd4390b6da8168ffc02aa42c7e',
  site: 'datadoghq.com',
  service: 'web-chat-bot',
  env: window['DD-ENV'],
  version: '2.2.0',
  forwardErrorsToLogs: true,
  sampleRate: 100,
  useCrossSiteSessionCookie: true
});

datadogRum.startSessionReplayRecording();

toggleWidget();
